<template>
  <v-navigation-drawer
    app
    width="300px"
    permanent
    :right="desktopmenu"
  >
    <template v-slot:prepend>
      <div class="text-h6 pt-5 pr-2 pl-2 pb-0 font-weight-bold text-center">
        {{ title }}
      </div>
      <div
        class="text-body-2 pr-2 pl-2 pb-5 pt-2"
        v-html="description"
      />
    </template>
    <v-expansion-panels
      v-model="panel"
      class="mt-1 pl-1 pr-1 mb-1"
      accordion
    >
      <v-expansion-panel
        v-for="(content, i) in contents"
        :key="i"
        hide-actions
        class="pa-0"
        active-class="tertiary"
        @click.native.stop="changeChapter(content)"
      >
        <v-expansion-panel-header class="pr-3 pl-3 pt-2 pb-2">
          <span class="text-subtitle-1 font-weight-medium">{{ content.title }}</span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="pa-0 pt-0">
          <v-card-text
            class="black--text pt-0 pl-2 pr-2 pb-1"
            v-html="assertMaxChars(content.description)"
          />
          <v-btn
            v-if="content && content.description && content.description.length >= maxCharsOnDrawerDescription"
            depressed
            block
            small
            color="primary"
            class="white--text mt-1 mb-2"
            @click="descriptionDialog = true"
          >
            {{ $t('common.viewMore') }}
          </v-btn>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-dialog
      v-model="descriptionDialog"
      max-width="590"
    >
      <v-card>
        <v-card-title class="headline grey lighten-4 mb-3">
          {{ currentContent.title }}
          <v-spacer />
          <v-btn
            icon
            small
            color="primary"
            @click="descriptionDialog = false"
          >
            <v-icon color="black">
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text
          class="black--text"
          v-html="currentContent.description"
        />
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>
<script>
export default {
  name: 'NavigationDrawerDesktop',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    currentContent: {
      type: Object,
      default: () => { },
    },
    contentIndex: {
      type: Number,
      default: 1,
    },
    contents: {
      type: Array,
      default: () => { },
    },
  },
  data() {
    return {
      maxCharsOnDrawerDescription: 310,
      descriptionDialog: false,
    };
  },
  computed: {
    panel: {
      get() {
        return this.contentIndex;
      },
      set(newValue) {
        if (newValue && newValue !== this.contentIndex) {
          this.$emit('changeContent', newValue);
        }
      },
    },
    desktopmenu() {
      return this.$store.state.UIParametersObj.desktopmenu === 'right';
    },
  },
  methods: {
    assertMaxChars(text) {
      if ( text && text.length >= this.maxCharsOnDrawerDescription) {
        const truncatedText = text.substring(0, this.maxCharsOnDrawerDescription);
        return `${truncatedText}...`;
      }
      return text;
    },
    changeChapter(content) {
      this.$emit('changeChapter', content.id);
    },
  },
};
</script>
<style>
.hide-big-description-text {
  max-width: 500ch;
  overflow: hidden;
  text-overflow: ellipsis;
}
.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 50px;
}
.v-expansion-panel-content__wrap {
  padding: 0 5px 5px;
}
::-webkit-scrollbar {
  width: 7px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #263238;
  border-radius: 0px;
  opacity: 0.7;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
